export default {
  getters: {
    flashMessage: (state) => state.flashMessage,
  },
  mutations: {
    HIDE_FLASH(state) {
      if (state.flashMessage) {
        const lState = state;
        lState.flashMessage = undefined;
      }
    },
    SHOW_FLASH(state, payload) {
      if (state.flashMessage === undefined) {
        const { body } = payload;
        let duration = 5;
        const lState = state;
        let title = '';
        let type = 'default';
        if (payload.duration !== undefined) {
          duration = payload.duration;
        }
        if (payload.type !== undefined) {
          type = payload.type;
        }
        if (payload.title !== undefined) {
          title = payload.title;
        }
        lState.flashMessage = {
          body,
          duration,
          title,
          type,
        };
      }
    },
  },
  state: {
    flashMessage: undefined,
  },
};
